// extracted by mini-css-extract-plugin
module.exports = {"BrownoutAnxiety":"BrownoutAnxiety_BrownoutAnxiety__kHBoY"};